export default __webpack_public_path__ + "static/media/logo_full.a3be2413.png";